import { render, staticRenderFns } from "./SaveOrderMobile.vue?vue&type=template&id=fcfa6d12"
import script from "./SaveOrderMobile.vue?vue&type=script&lang=js"
export * from "./SaveOrderMobile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports